import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "../AdminDashboard.css";
import MyContext from "../../../MyContext";
import { Form, FormControl, Modal } from "react-bootstrap";
import rightArrow from "../../../images/Arrow - Right.svg"
import downArrow from "../../../images/Arrow - Down.svg"
import NoIndex from "../../../components//NoIndex";
import { useNavigate } from "react-router-dom";
import { X, Eye, Pencil } from 'lucide-react';
// Predefined customization sets
const customizationSets = [
  {
    customize_field: "Sweetness",
    options: ["Less Sweet", "Sweet", "High Sweet"]
  },
  {
    customize_field: "Spice Level",
    options: ["Mild", "Medium", "Spicy"]
  },
  {
    customize_field: "Oil Preference",
    options: ["Low Oil", "Normal Oil", "Extra Oil"]
  },
  {
    customize_field: "Butter Topping",
    options: ["No Butter", "Butter", "Extra Butter"]
  },
  {
    customize_field: "Cooking Type",
    options: ["Fried", "Grilled", "Steamed"]
  },
  {
    customize_field: "Onion & Garlic",
    options: ["No Onion", "No Garlic"]
  },
];
function AdminNewCatalogue({ Admin }) {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [loading, setLoading] = useState(false);
  const [Clients, setClients] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [userID, setuserID] = useState('');
  const [longitude, setLongitude] = useState(null);
  const [ClientName, setClientName] = useState('')

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, []);




  const FetchClientCall = async () => {
    setLoading(true);
    try {

      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);

        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    FetchClientCall();
  }, []);
  function HandleClientChange({ code, name }) {
    setuserID(code);
    setClientName(name)

  }
  // Client Side Catalohue code
   const [catalogueStore, setCatalogueStore] = useState([]);
   const [csvData, setCsvData] = useState(null);
   const navigate = useNavigate();
   const [searchText, setSearchText] = useState("");
   const [cart, setCart] = useState([]);
   const [cartMap, setCartMap] = useState({});
   const [screen, setScreen] = useState("First_item_list");
   const [deliveryType, setDeliveryType] = useState("");
   const [selectedDeliveryType, setSelectedDeliveryType] = useState("");
   const [expandedCategories, setExpandedCategories] = useState([]);
   const [isCartLoadingState, setIsCartLoadingState] = useState(false);
 
   const [isCartFetchingState, setIsCartFetchingState] = useState(false);
   const [customizationModal, setCustomizationModal] = useState(null);
   const [selectedCustomizationSet, setSelectedCustomizationSet] = useState(null);
   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
   const [selectedCustomizations, setSelectedCustomizations] = useState([]);
   const [itemsToShow, setItemsToShow] = useState();
   const [availabilityData, setAvailabilityData] = useState({});
   const [viewModalItem, setViewModalItem] = useState(null);
   const [viewModalTab, setViewModalTab] = useState("details");
   const [printerList, setPrinterList] = useState([]);
   const [printerLoading, setPrinterLoading] = useState(false);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [isEditingDetails, setIsEditingDetails] = useState(false);
   const [editableDetails, setEditableDetails] = useState({});
 
   const [availabilityUpdateLoading, setAvailabilityUpdateLoading] = useState(false);
 
   const handleCheckboxChange = (itemId, field) => {
     setAvailabilityData((prev) => ({
       ...prev,
       [itemId]: {
         ...prev[itemId],
         [field]: !prev[itemId][field],
       },
     }));
   };
   const handleSubmit = async (e, itemId) => {
     e.preventDefault();
     const updated = availabilityData[itemId];
 
 
     try {
       const requestBody = {
         userid: userID,
         itemId: itemId,
         homeDelivery: updated.homeDelivery,
         takeaway: updated.takeaway,
         dining: updated.dineIn
       };
 
       const response = await axios.post(
         `${baseUrl}/api/Order/v1.0/changeItemAvailability`,
         requestBody,
         config
       );
 
 
 
       if (response.data.responseCode === "00") {
         toast.success(
           response?.data?.responseMessage || "Status updated successfully!"
         );
         allcatalogueAPI();
       } else {
         Swal.fire({
           title: "Error",
           text: response.data.responseMessage || "Something went wrong.",
           icon: "error",
           confirmButtonText: "Okay",
         });
       }
     } catch (error) {
       Swal.fire({
         title: "Error",
         text: "An error occurred while processing your request.",
         icon: "error",
         confirmButtonText: "Okay",
       });
     }
 
 
 
 
 
   };
   const allcatalogueAPI = async () => {
     setLoading(true);
     try {
       const requestBody = {
         userid: userID,
         secret: "string",
       };
       const response = await axios.post(
         `${baseUrl}/api/Order/v1.0/getCatalogItems`,
         requestBody,
         config
       );
       console.log(response.data.response);
       if (response.data.responseCode === "00") {
         setCatalogueStore(response.data.response);
       }
     } catch {
     } finally {
       setLoading(false);
     }
   };
 
   useEffect(() => {
     allcatalogueAPI();
   }, [userID]);
 
   const [searchTerm, setSearchTerm] = useState(""); // Add state for search term
   // Filter the catalogue based on search term
   const filteredCatalogue = catalogueStore.filter(
     (item) =>
       searchTerm.trim() === "" // If search box is empty, show full list
         ? true
         : item.title?.toLowerCase().includes(searchTerm.toLowerCase()) // Case-insensitive filter
   );
   useEffect(() => {
     if (catalogueStore && catalogueStore.length > 0) {
       const firstCatId = String(catalogueStore[0].cat_id);
       setExpandedCategories([firstCatId]);
     }
   }, [catalogueStore]);
 
   const toggleCategory = (catId) => {
     setExpandedCategories((prev) =>
       prev.includes(catId)
         ? prev.filter((id) => id !== catId)
         : [...prev, catId]
     );
   };
 
   const filteredCategories = useMemo(() => {
     if (!catalogueStore) return [];
     return catalogueStore
       .map((category) => {
         const filteredItems = (category.menu_items || []).filter((item) =>
           item?.item_name?.toLowerCase().includes(searchText.toLowerCase())
         );
         return {
           ...category,
           menu_items: filteredItems, // make sure to keep it as `menu_items` so your component works
         };
       })
       .filter((category) => category.menu_items.length > 0); // remove empty categories
   }, [catalogueStore, searchText]);
   useEffect(() => {
     if (searchText.trim()) {
       const matchedIds = filteredCategories.map((cat) => String(cat.cat_id));
       setExpandedCategories(matchedIds);
     } else {
       // Optional: collapse all
       const firstCatId = String(catalogueStore?.[0]?.cat_id || "");
       setExpandedCategories(firstCatId ? [firstCatId] : []);
     }
   }, [filteredCategories, searchText, catalogueStore]);
 
   const toggleStockStatus = async (item) => {
     const newStatus = item.inStock ? "N" : "Y";
 
     try {
       const requestBody = {
         userid: userID, // Ensure this is available in your scope
         id: item.item_id, // Make sure `item.id` refers to the item's ID
         stock: "1",
         inStock: newStatus,
         type: "item",
       };
 
       const response = await axios.post(
         `${baseUrl}/api/Order/v1.0/updateStock`,
         requestBody,
         config
       );
 
 
 
       if (response.data.responseCode === "00") {
         toast.success(
           response?.data?.responseMessage || "Status updated successfully!"
         );
         allcatalogueAPI();
       } else {
         Swal.fire({
           title: "Error",
           text: response.data.responseMessage || "Something went wrong.",
           icon: "error",
           confirmButtonText: "Okay",
         });
       }
     } catch (error) {
       Swal.fire({
         title: "Error",
         text: "An error occurred while processing your request.",
         icon: "error",
         confirmButtonText: "Okay",
       });
     }
   };
 
   // Open customization modal for an item
   const openCustomizationModal = (item) => {
     setSelectedCategoryId(item);
     setCustomizationModal(true);
   };
 
   // Handle customization set selection
   const handleCustomizationSetChange = (index) => {
     setSelectedCustomizationSet(index);
   };
 
   const handleCustomizationApply = async () => {
     const categoryId = selectedCategoryId; // Replace with actual selected category ID
 
     const customizationArray = selectedCustomizations.map((index) => {
       const set = customizationSets[index];
       return {
         customization_type: "customize",
         customize_field: set.customize_field,
         options: set.options,
       };
     });
 
     const payload = {
       userid: userID,
       id: categoryId,
       customizations: customizationArray, // Now an array
       type: "category",
       operation: "add",
     };
 
     try {
 
       const res = await axios.post(
         `${baseUrl}/api/Order/v1.0/updateCustomization`,
         payload,
         config
       );
 
       if (res.data.responseCode === "00") {
         toast.success(res.data.data.message)
       }
       else {
         toast.error(res.data.data.message)
       }
 
     } catch (err) {
       console.error("Failed to send customization:", err);
     }
 
     setCustomizationModal(false);
   };
   const [addPrinterModalOpen, setAddPrinterModalOpen] = useState(false);
   const [addPrinterFormData, setAddPrinterFormData] = useState({
     printerName: "",
     printerAlias: "",
     deviceName: "",
     deviceNumber: "",
   });
 
   const handlePrinterInputChange = (e) => {
     setAddPrinterFormData({
       ...addPrinterFormData,
       [e.target.name]: e.target.value,
     });
   };
 
   const handleAddPrinterSubmit = async () => {
     const payload = {
       userid: String(userID),
       ...addPrinterFormData,
     };
 
     try {
       const res = await fetch(`${baseUrl}/api/Order/v1.0/addPrinter`, {
         method: "POST",
         headers: {
           ...config.headers,
           "Content-Type": "application/json",
         },
         body: JSON.stringify(payload),
       });
 
       const data = await res.json();
       if (data.responseCode === "00") {
         Swal.fire("Success", data.responseMessage, "success");
         setAddPrinterModalOpen(false);
         setAddPrinterFormData({
           printerName: "",
           printerAlias: "",
           deviceName: "",
           deviceNumber: "",
         });
       } else {
         Swal.fire("Error", data.responseMessage, "error");
       }
     } catch (error) {
       Swal.fire("Error", "Something went wrong", "error");
     }
   };
   const fetchPrinterList = async () => {
     try {
       setPrinterLoading(true);
       const res = await axios.post(`${baseUrl}/api/Order/v1.0/getPrinters`, {
         userid: userID,
       }, config);
 
       if (res.data.responseCode === "00") {
         setPrinterList(res.data.response || []);
       } else {
         toast.error("Failed to load printers");
       }
     } catch (err) {
       toast.error("Error fetching printers");
     } finally {
       setPrinterLoading(false);
     }
   };
 
   const handleSavePrinterToItem = async () => {
     if (!selectedPrinter) return toast.error("Please select a printer first");
 
     try {
       const payload = {
         userid: userID,
         itemId: viewModalItem.item_id,
         printerCode: selectedPrinter?.printerCode,
         printerAlias: selectedPrinter?.printerAlias,
       };
 
       const res = await axios.post(`${baseUrl}/api/Order/v1.0/addPrinterCodeToItem`, payload, config);
 
       if (res.data.responseCode === "00") {
         Swal.fire("Success", res.data.responseMessage, "success");
       } else {
         Swal.fire("Error", res.data.responseMessage, "error");
       }
     } catch (err) {
       Swal.fire("Error", "Something went wrong", "error");
     }
   };
 
   const handleUpdateItem = async () => {
     try {
       const payload = {
         userid: String(userID),
         itemId: editableDetails.item_id,
         itemName: editableDetails.item_name,
         sizeId: String(editableDetails.sizeId || ""),
         category: String(editableDetails.category || ""),
         size: String(editableDetails.size || ""),
         sellingPrice: String(editableDetails.sellingPrice || ""),
         // NEW fields
         homeDeliveryPrice: String(editableDetails.homeDeliveryPrice ?? ""),
         takewayPrice: String(editableDetails.takewayPrice ?? ""),
         diningPrice: String(editableDetails.diningPrice ?? ""),
         taxPercentage: String(editableDetails.taxPercentage ?? ""),
       };
 
       const res = await axios.post(
         `${baseUrl}/api/Order/v1.0/updateCatalogItems`,
         payload,
         config
       );
 
       if (res.data.responseCode === "00") {
         toast.success(res.data.responseMessage || "Item updated successfully");
         setIsEditingDetails(false);
         await allcatalogueAPI();
         // refresh current modal item from latest list (optional but nice)
         const freshCat = (catalogueStore || []).flatMap(c => c.menu_items || []);
         const updated = freshCat.find(it => it.item_id === editableDetails.item_id);
         if (updated) {
           setViewModalItem(updated);
         }
       } else {
         Swal.fire("Error", res.data.responseMessage || "Update failed", "error");
       }
     } catch (err) {
       Swal.fire("Error", "Something went wrong", "error");
     }
   };
 
  return (
    <div className="marginRight">
      <>
        <div className="d-flex justify-content-center text-center">
          <ToastContainer />
        </div>
        <div>
          <div
            className="p-4 bg-white"
            style={{
              height: "100vh",
              fontFamily: "Nunito,sans-serif",
            }}
          >
            <div className="row g-3 px-4 admin-catalogue-wrapper">
              {/* Left Card */}
              <div className="col-md-4 admin-popup">
                <div className="admin-left-card text-white p-4 text-start rounded-2 h-100">
                  <h5 className="fw-bold mb-2 admin-text-animate">Restaurant Catalogue</h5>
                  <hr className="admin-divider" />
                  <p className="mb-0 small admin-text-animate">
                    View, organize, and manage your restaurant's full catalogue including dishes, pricing, and availability settings.
                  </p>
                </div>
              </div>

              {/* Right Card */}
              <div className="col-md-8 admin-popup">
                <div className="admin-right-card p-4 rounded-2 h-100">
                  <h5 className="admin-restaurant-subtitle mb-3">Select Catalogue</h5>
                  <select
                    className="form-select form-select-sm admin-custom-dropdown"
                    aria-label="Select Client"
                    onChange={(e) => {
                      const selectedData = JSON.parse(e.target.value);
                      HandleClientChange(selectedData);
                    }}
                  >
                    <option value="">Select Client...</option>
                    {Clients.map((item, index) => (
                      <option
                        key={index}
                        value={JSON.stringify({ code: item.us_code, name: item.us_name })}
                      >
                        {item.us_code} : {item.us_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* <div className="px-4 justify-content-center">
                            <Form className="d-flex justify-content-between pb-4">
                                <Form.Label className="CreateCampaign">Catalogue</Form.Label>
                            </Form>

                            <div className="border bg-light p-2 rounded-3 mb-3"><h4 className="mt-1">Select Catalogue</h4><div><select class="form-select form-select-sm" aria-label="Small select example" onChange={(e) => { setuserID(e.target.value) }}>
                                <option selected>Open this select menu</option>
                                {Clients.map((item, index) => <option value={item.us_code}>{item.us_code} : <strong>{item.us_name}</strong></option>)}


                            </select></div></div>
                        </div> */}
            {userID && <div className="px-4">
              <hr />
              <NoIndex />
              <div className="d-flex justify-content-center text-center">
                <ToastContainer />
              </div>
              <div
                      className=" bg-white"
                      style={{
                        // backgroundColor: "#F8F8F8",
                        fontFamily: "Nunito, sans-serif",
                      }}
                    >
                      <div className="bg-white px-4">
                        <div className="  " style={{ borderRadius: "10px" }}>
                          <div className="d-flex justify-content-between pb-2">
                            <div className="CreateCampaign p-0 m-0">Catalogue Items</div>
                            <div className="d-flex justify-content-between">
                              <Form className="">
                                <FormControl
                                  type="text"
                                  placeholder="Search"
                                  className="bg-light"
                                  value={searchText}
                                  onChange={(e) => setSearchText(e.target.value)}
                                />
                              </Form>
                              <div></div>
                              <div>
                                <button className="blue-button single-line-css ms-3" onClick={() => setAddPrinterModalOpen(true)}>
                                  Add Printer
                                </button>
                              </div>
                            </div>
                          </div>
                          {loading ? (
                            <div className=" m-5 p-5 d-flex justify-content-center">
                              <div className="loader "></div>
                            </div>
                          ) : (
                            <>
                              <div className="p-0 m-0 pb-12">
                                <div className=" bg-gray-10 rounded p-1"></div>
                                {/* <div className="border-b border-gray-400 mb-5"></div> */}
                                {filteredCategories.map((category) => {
                                  const catId = String(category.cat_id);
                                  const isExpanded = expandedCategories.includes(catId);
            
                                  const itemsToShow = isExpanded
                                    ? category.menu_items
                                    : category.menu_items.slice(0, 0);
            
                                  itemsToShow.forEach((item) => {
                                    if (!availabilityData[item.item_id]) {
                                      setAvailabilityData((prev) => ({
                                        ...prev,
                                        [item.item_id]: {
                                          homeDelivery: item.homeDeliveryAvailability,
                                          takeaway: item.takeawayAvailability,
                                          dineIn: item.diningAvailability,
                                        },
                                      }));
                                    }
                                  });
            
                                  return (
                                    <div key={catId}>
                                      <div className="d-flex justify-content-between align-items-center my-3">
                                        <p
                                          className="fw-bold text-dark cursor-pointer"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => toggleCategory(catId)}
                                        >
                                          {category.category_name?.length > 20
                                            ? category.category_name
                                            : category.category_name}
                                        </p>
            
            
                                        <div className="d-flex justify-content-end gap-3" >
                                          <button
                                            className="btn btn-sm btn-primary ms-3"
                                            onClick={() => openCustomizationModal(catId)}
                                          >
                                            Customize
                                          </button>
                                          {category.menu_items.length > 0 && (
                                            <button
                                              className="btn btn-sm px-2 py-1 rounded bg-light text-primary"
                                              onClick={() => toggleCategory(catId)}
                                            >
                                              {isExpanded ? (
                                                <img
                                                  src={downArrow}
                                                  className="img-fluid"
                                                  style={{ width: "1rem", height: "1rem" }}
                                                  alt=""
                                                />
                                              ) : (
                                                <img
                                                  src={rightArrow}
                                                  className="img-fluid"
                                                  style={{ width: "1rem", height: "1rem" }}
                                                  alt=""
                                                />
                                              )}
                                            </button>
                                          )}
                                        </div>
            
                                      </div>
            
                                      <div className="ps-1">
                                        {itemsToShow.map((item) => (
                                          <div className="d-flex align-items-center  py-2 bg-light rounded my-2">
                                            {/* Image */}
                                            <div
                                              className="flex-shrink-0 ms-2"
                                              style={{
                                                width: "5rem",
                                                height: "5rem",
                                                borderRadius: "10px",
                                                overflow: "hidden",
                                              }}
                                            >
                                              <img
                                                src={item.photo}
                                                alt={item.name}
                                                loading="lazy"
                                                decoding="async"
                                                className="w-100 h-100 object-fit-cover"
                                              />
                                            </div>
            
                                            {/* Text Content */}
                                            <div className="flex-grow-1 text-start ms-3">
                                              <p className="fw-medium mb-1 ">
                                                {item.item_name}
                                              </p>
                                              <p className="text-muted small mb-0">
                                                {item.prices.formatted_price}
                                              </p>
                                            </div>
                                            <div class="d-flex flex-wrap align-items-center">
            
                                              <button
                                                className="isancharr-create-btn btn btn-sm d-flex align-items-center gap-1 px-3 py-1 border-0"
                                                onClick={() => {
                                                  // parse category (it's a stringified array like '["2269","2276"]')
                                                  let categoryIds = [];
                                                  try { categoryIds = JSON.parse(item.category || "[]"); } catch { }
                                                  const prices = Array.isArray(item.prices) ? item.prices : [];
                                                  const first = prices[0] || {};
            
                                                  setViewModalItem(item);
                                                  setEditableDetails({
                                                    // keep original fields for read-only view
                                                    ...item,
            
                                                    // fields required by update API
                                                    item_id: item.item_id,                 // -> itemId
                                                    item_name: item.item_name,             // -> itemName
                                                    category: (() => {
                                                      try { return (JSON.parse(item.category || "[]") || [])[0] || ""; }
                                                      catch { return item.category || ""; }
                                                    })(),
            
                                                    // size/price from first price row
                                                    selectedPriceIndex: 0,
                                                    sizeId: first.size_id || "",
                                                    size: first.size || "",
                                                    sellingPrice: first.price || "",
            
                                                    // NEW fields
                                                    homeDeliveryPrice: first.homeDeliveryPrice ?? "",
                                                    takewayPrice: first.takewayPrice ?? "",
                                                    diningPrice: first.diningPrice ?? "",
                                                    taxPercentage: first.taxPercentage ?? "",
                                                  });
                                                  setIsEditingDetails(false);
                                                }}
            
                                                style={{
                                                  fontWeight: 600,
                                                  fontSize: "14px",
                                                  borderRadius: "999px",
                                                  color: "white",
                                                }}
                                              >
                                                <Eye size={16} />
                                                View
                                              </button>
            
            
                                            </div>
            
                                            <div className="d-flex align-items-center  p-2  rounded-3 ">
            
            
                                              <div className="d-flex align-items-center ms-3 p-2  rounded-3 ">
                                                <div className="me-1">
                                                  <span className="">In Stock</span>
                                                  {/* <span>{String(item.inStock)} In Stock</span> */}
                                                </div>
                                                <div className="order-switch d-flex align-items-center cursor-pointer">
                                                  <label className="order-switch-label mb-0">
                                                    <input
                                                      type="checkbox"
                                                      checked={item.inStock}
                                                      onChange={() => {
                                                        toggleStockStatus(item);
                                                      }}
                                                    />
                                                    <span
                                                      className={`order-slider order-round ms-2 ${item.inStock ? "on" : "off"
                                                        }`}
                                                    >
                                                      {item.inStock ? "ON" : "OFF"}
                                                    </span>
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                        <hr className="border-secondary" />
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    {customizationModal && (
                      <Modal show={customizationModal} onHide={() => setCustomizationModal(false)}>
                        <Modal.Header closeButton>
                          <Modal.Title>Customize Category</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {customizationSets.map((set, index) => (
                            <div key={index} className="form-check mb-2">
                              <input
                                className="form-check-input cursor-pointer"
                                type="checkbox"
                                id={`set-${index}`}
                                checked={selectedCustomizations.includes(index)}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setSelectedCustomizations((prev) => {
                                    if (isChecked) {
                                      return [...prev, index];
                                    } else {
                                      return prev.filter((i) => i !== index);
                                    }
                                  });
                                }}
                              />
                              <label className="form-check-label" htmlFor={`set-${index}`}>
                                {set.customize_field}
                              </label>
                              <div className="d-flex justify-content-start gap-2 mt-2">
                                {set.options.map((opt) => (
                                  <div key={opt} className=" bg-light px-2 py-1 rounded">{opt} </div>
            
                                ))}
                              </div>
                            </div>
                          ))}
                        </Modal.Body>
                        <Modal.Footer>
                          <button className="btn btn-secondary" onClick={() => setCustomizationModal(false)}>
                            Close
                          </button>
                          <button className="btn btn-primary" onClick={handleCustomizationApply}>
                            Apply Customization
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {viewModalItem && (
                      <Modal
                        show={!!viewModalItem}
                        onHide={() => setViewModalItem(null)}
                        centered
                        size="lg"
                        backdrop="static"
                        className="view-item-modal"
                      >
                        <Modal.Header closeButton className="border-0">
                          <Modal.Title className="fw-bold">
                            {viewModalItem.item_name}
                          </Modal.Title>
                        </Modal.Header>
            
                        <Modal.Body style={{ minHeight: "400px", maxHeight: "600px", overflowY: "auto" }}>
                          <div className="tab-header mb-3">
                            {["details", "availability", "printer"].map((tab) => (
                              <button
                                key={tab}
                                className={`tab-btn ${viewModalTab === tab ? "active" : ""}`}
                                onClick={() => {
                                  setViewModalTab(tab);
                                  if (tab === "printer") fetchPrinterList();
                                }}
                              >
                                {tab.charAt(0).toUpperCase() + tab.slice(1)}
                              </button>
                            ))}
                          </div>
            
                          <div className="tab-content">
                            {viewModalTab === "details" && (
                              <>
                                <div className="d-flex justify-content-between align-items-start">
                                  <h5 className="mb-3 fw-semibold">Item Overview</h5>
                                  <button
                                    className="btn btn-sm d-flex align-items-center gap-1 text-primary bg-transparent border-0"
                                    onClick={() => setIsEditingDetails(!isEditingDetails)}
                                  >
                                    <Pencil size={16} />
                                    {isEditingDetails ? "Cancel" : "Edit"}
                                  </button>
                                </div>
            
                                <div className="d-flex gap-4 flex-wrap">
                                  <div style={{ width: "200px", height: "200px", borderRadius: "10px", overflow: "hidden" }}>
                                    <img src={editableDetails.photo} alt={editableDetails.item_name} className="w-100 h-100 object-fit-cover border" />
                                  </div>
            
                                  <div className="flex-grow-1">
                                    {isEditingDetails ? (
                                      <>
                                        <div className="mb-2">
                                          <label className="form-label">Item Name</label>
                                          <input
                                            className="form-control"
                                            value={editableDetails.item_name}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, item_name: e.target.value })
                                            }
                                          />
                                        </div>
            
                                        {/* Category is an ID string; prefilled with the first ID from item.category */}
                                        <div className="mb-2">
                                          <label className="form-label">Category (ID)</label>
                                          <input
                                            className="form-control"
                                            value={editableDetails.category || ""}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, category: e.target.value })
                                            }
                                          />
                                        </div>
            
                                        {/* Size picker from prices array */}
                                        <div className="mb-2">
                                          <label className="form-label">Size</label>
                                          <select
                                            className="form-select"
                                            value={editableDetails.selectedPriceIndex ?? 0}
                                            onChange={(e) => {
                                              const idx = Number(e.target.value);
                                              const p = viewModalItem.prices[idx] || {};
                                              setEditableDetails((prev) => ({
                                                ...prev,
                                                selectedPriceIndex: idx,
                                                sizeId: p.size_id || "",
                                                size: p.size || "",
                                                sellingPrice: p.price || "",
                                                // NEW fields sync from selected price row if present
                                                homeDeliveryPrice: p.homeDeliveryPrice ?? prev.homeDeliveryPrice ?? "",
                                                takewayPrice: p.takewayPrice ?? prev.takewayPrice ?? "",
                                                diningPrice: p.diningPrice ?? prev.diningPrice ?? "",
                                                taxPercentage: p.taxPercentage ?? prev.taxPercentage ?? "",
                                              }));
                                            }}
                                          >
                                            {(viewModalItem.prices || []).map((p, i) => (
                                              <option key={i} value={i}>
                                                {p.size} — ₹{p.price}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
            
                                        {/* Selling price (editable) */}
                                        <div className="mb-2">
                                          <label className="form-label">Selling Price</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={editableDetails.sellingPrice || ""}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, sellingPrice: e.target.value })
                                            }
                                          />
                                        </div>
                                        {/* Home Delivery Price */}
                                        <div className="mb-2">
                                          <label className="form-label">Home Delivery Price</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={editableDetails.homeDeliveryPrice || ""}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, homeDeliveryPrice: e.target.value })
                                            }
                                          />
                                        </div>
            
                                        {/* Takeway Price (as spelled in API) */}
                                        <div className="mb-2">
                                          <label className="form-label">Takeway Price</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={editableDetails.takewayPrice || ""}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, takewayPrice: e.target.value })
                                            }
                                          />
                                        </div>
            
                                        {/* Dining Price */}
                                        <div className="mb-2">
                                          <label className="form-label">Dining Price</label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={editableDetails.diningPrice || ""}
                                            onChange={(e) =>
                                              setEditableDetails({ ...editableDetails, diningPrice: e.target.value })
                                            }
                                          />
                                        </div>
            
                                        {/* Tax Percentage */}
                                        <div className="mb-2">
                                          <label className="form-label">Tax Percentage</label>
                                          <select
                                            className="form-select"
                                            value={editableDetails.taxPercentage ?? ""}
                                            onChange={(e) =>
                                              setEditableDetails({
                                                ...editableDetails,
                                                taxPercentage: Number(e.target.value),
                                              })
                                            }
                                          >
                                            <option value="" disabled>Select tax %</option>
                                            <option value={0}>0</option>
                                            <option value={5}>5</option>
                                            <option value={12}>12</option>
                                            <option value={18}>18</option>
                                            <option value={28}>28</option>
                                          </select>
            
                                        </div>
            
                                      </>
                                    ) : (
                                      <>
                                        <p className="mb-2"><strong>Item ID:</strong> {editableDetails.item_id}</p>
                                        <p className="mb-2"><strong>Item Name:</strong> {editableDetails.item_name}</p>
                                        <p className="mb-2"><strong>Category IDs:</strong> {(() => { try { return (JSON.parse(viewModalItem.category || "[]") || []).join(", "); } catch { return viewModalItem.category; } })()}</p>
                                        <p className="mb-2"><strong>Selected Size:</strong> {editableDetails.size}</p>
                                        <p className="mb-2"><strong>Selling Price:</strong> ₹{editableDetails.sellingPrice}</p>
                                      </>
                                    )}
            
                                  </div>
                                </div>
            
                                {isEditingDetails && (
                                  <div className="text-end mt-3">
                                    <button className="btn btn-primary" onClick={async () => {
                                      // Dummy API call simulation
                                      handleUpdateItem();
                                    }}>
                                      Save Changes
                                    </button>
                                  </div>
                                )}
            
                                <hr />
            
                                {viewModalItem.prices?.map((priceObj, idx) => (
                                  <div key={idx} className="mb-3">
                                    <h6 className="fw-semibold">Size: {priceObj.size}</h6>
                                    <p className="mb-1"><strong>Price:</strong> {priceObj.formatted_price}</p>
            
                                    {priceObj.customizations?.length > 0 && (
                                      <div className="border rounded p-2 bg-light">
                                        <h6 className="fw-semibold">Customizations</h6>
                                        <table className="table table-sm table-bordered">
                                          <thead className="table-light">
                                            <tr>
                                              <th>Field</th>
                                              <th>Options</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {priceObj.customizations.map((c, i) => (
                                              <tr key={i}>
                                                <td>{c.customize_field}</td>
                                                <td>{c.options.join(", ")}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </>
                            )}
            
            
                            {viewModalTab === "availability" && (
                              <form className="d-flex flex-column gap-3" onSubmit={(e) => handleSubmit(e, viewModalItem.item_id)}>
                                <p className="text-muted">Configure availability for this item:</p>
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="avail-home" checked={availabilityData[viewModalItem.item_id]?.homeDelivery || false} onChange={() => handleCheckboxChange(viewModalItem.item_id, "homeDelivery")} />
                                  <label className="form-check-label" htmlFor="avail-home">Home Delivery</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="avail-take" checked={availabilityData[viewModalItem.item_id]?.takeaway || false} onChange={() => handleCheckboxChange(viewModalItem.item_id, "takeaway")} />
                                  <label className="form-check-label" htmlFor="avail-take">Takeaway</label>
                                </div>
                                <div className="form-check">
                                  <input className="form-check-input" type="checkbox" id="avail-dine" checked={availabilityData[viewModalItem.item_id]?.dineIn || false} onChange={() => handleCheckboxChange(viewModalItem.item_id, "dineIn")} />
                                  <label className="form-check-label" htmlFor="avail-dine">Dine-in</label>
                                </div>
                                <button className="btn btn-success mt-2" type="submit">Save Availability</button>
                              </form>
                            )}
            
                            {viewModalTab === "printer" && (
                              <>
                                <p className="text-muted mb-2">Assign a printer to this item. This ensures the order slip is printed automatically for the selected section.</p>
                                {printerLoading ? (
                                  <div className="text-center py-3">Loading printers...</div>
                                ) : (
                                  <select
                                    className="form-select bg-light border-secondary"
                                    onChange={(e) =>
                                      setSelectedPrinter(
                                        printerList.find((p) => p.printerCode === e.target.value)
                                      )
                                    }
                                  >
                                    <option value="">Select Printer</option>
                                    {printerList.map((printer) => (
                                      <option key={printer.printerCode} value={printer.printerCode}>
                                        {printer.printerName}-{printer.printerAlias}
                                      </option>
                                    ))}
                                  </select>
                                )}
                                <div className="d-flex gap-2 ">  <button
                                  className="btn btn-primary mt-3"
                                  onClick={handleSavePrinterToItem}
                                  disabled={!selectedPrinter}
                                >
                                  Save Printer
                                </button>
                                  <div>
                                    <button className="btn btn-primary mt-3" onClick={() => setAddPrinterModalOpen(true)}>
                                      Add Printer
                                    </button></div>
            
                                </div>
                              </>
                            )}
                          </div>
                        </Modal.Body>
            
            
            
                        <Modal.Footer className="d-flex justify-content-between">
                          <button className="btn btn-outline-secondary" onClick={() => setViewModalItem(null)}>Close</button>
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              navigate(`/Orders/Catalogue/edit-ingredients/${viewModalItem.item_id}`, {
                                state: {
                                  name: viewModalItem.item_name,
                                  photo: viewModalItem.photo,
                                },
                              })
                            }
                          >
                            Ingredients Edit
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                    {addPrinterModalOpen && (
                      <div
                        className="modal-backdrop"
                        style={{
                          position: "fixed",
                          top: 0, left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0,0,0,0.6)",
                          zIndex: 9999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className="modal-content p-4"
                          style={{
                            background: "#f9f9f9ff",
                            borderRadius: "12px",
                            width: "400px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            color: "black",
                            position: "relative",
                          }}
                        >
                          <div style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }} onClick={() => setAddPrinterModalOpen(false)}>
                            <X size={20} />
                          </div>
                          <h5 className="mb-3">Add New Printer</h5>
            
                          <div className="mb-3">
                            <label className="form-label">Printer Name</label>
                            <input type="text" name="printerName" value={addPrinterFormData.printerName} onChange={handlePrinterInputChange} className="form-control border-secondary" />
                          </div>
            
                          <div className="mb-3">
                            <label className="form-label">Printer Alias</label>
                            <input type="text" name="printerAlias" value={addPrinterFormData.printerAlias} onChange={handlePrinterInputChange} className="form-control border-secondary" />
                          </div>
            
                          <div className="mb-3">
                            <label className="form-label">Device Name</label>
                            <input type="text" name="deviceName" value={addPrinterFormData.deviceName} onChange={handlePrinterInputChange} className="form-control border-secondary" />
                          </div>
            
                          <div className="mb-3">
                            <label className="form-label">Device Number</label>
                            <input type="text" name="deviceNumber" value={addPrinterFormData.deviceNumber} onChange={handlePrinterInputChange} className="form-control  border-secondary" />
                          </div>
            
                          <button className="blue-button w-100 mt-2" onClick={handleAddPrinterSubmit}>
                            Save Printer
                          </button>
            
                        </div>
                      </div>
                    )}
            </div>}
          </div>
        </div>
      </>
    </div>
  )
}

export default AdminNewCatalogue